export default {"src":"/_next/static/media/arrow-icon.a7b0e82f.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};